@layer reset, default;

@layer reset {
  :host {
    display: block;
  }
}

@layer default {
  :host .gcds-label {
    display: block;
    max-width: 100%;
    font: var(--gcds-label-font-desktop);
    margin: var(--gcds-label-margin) !important;
    color: var(--gcds-label-text);
    cursor: pointer;

    @media only screen and (width < 48em) {
      font: var(--gcds-label-font-mobile);
    }

    &.label--hidden {
      overflow: hidden;
      opacity: 0;
      width: 0;
      height: 0;
      margin: 0;
    }

    .label--required {
      font-weight: var(--gcds-label-required-font-weight);
      margin: var(--gcds-label-required-margin) !important;
    }
  }
}
